// extracted by mini-css-extract-plugin
module.exports = {"main":"SideMenuItem_main__3uq_r","iconImage":"SideMenuItem_iconImage__1qlbh"};